// extracted by mini-css-extract-plugin
export default {"listheader":"MessageSchedListHeader_listheader__o-kPT"};